import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

interface QuietLinkProps {
  children: ReactNode;
  /** Hash to land on within `to`. */
  hash?: string;
  /** An in-page or outbound target. Mutually exclusive with `to`. */
  href?: string;
  /** An internal route. */
  to?: string;
}

/**
 * The tertiary hand-off, and the only underlined thing in the system: a label
 * over a hairline rule with a trailing arrow. It is never a blue link — hover
 * takes both the label and its rule to deep teal.
 *
 * The arrow is decorative; the label already says where the link goes.
 */
export function QuietLink({
  children,
  hash,
  href,
  to,
}: Readonly<QuietLinkProps>) {
  const label = (
    <>
      {children} <span aria-hidden="true">↗</span>
    </>
  );

  if (to) {
    return (
      <Link className="quiet-link" hash={hash} to={to}>
        {label}
      </Link>
    );
  }

  return (
    <a className="quiet-link" href={href}>
      {label}
    </a>
  );
}
